import React, { useMemo } from 'react';
import { sections } from './data/onboarding';
import { useScrollSpy } from './hooks/useScrollSpy';
import { useScrollProgress } from './hooks/useScrollProgress';
import { useProgress } from './hooks/useProgress';
import { Hero } from './components/Hero';
import { SectionNav } from './components/SectionNav';
import { SectionCard } from './components/SectionCard';
import { StepList } from './components/StepList';
import { TourAreas } from './components/TourAreas';
import { TogetherPanel } from './components/TogetherPanel';
import { ExploreGrid } from './components/ExploreGrid';
import { NeedAHand } from './components/NeedAHand';
import { Reveal } from './components/Reveal';
const togetherIntro: Record<string, string> = {
  'ai-knowledge-base': 'Your Voice AI receptionist answers callers using a knowledge base about your business — so it sounds like someone who actually works for you. We build this with you.',
  'ai-agent-number': 'Your Voice AI runs on its own dedicated phone number and answers 24/7, so nothing rings out. We set up the number and the agent with you.'
};
export function App() {
  const ids = useMemo(() => [...sections.map(section => section.id), 'need-a-hand'], []);
  const activeId = useScrollSpy(ids);
  const scrollProgress = useScrollProgress();
  const {
    done,
    isDone,
    toggle
  } = useProgress();
  return <div className="min-h-full w-full bg-[#0a0a0a] text-white" data-id="element-0" data-mp="7stfczkdj46">
      <Hero data-id="element-1" data-mp="2zmo3z3zwcd00" />

      <div className="mx-auto flex w-full max-w-6xl flex-col px-0 pb-20 sm:pb-28 lg:flex-row lg:gap-10 lg:px-8 lg:pt-12" data-id="element-2" data-mp="2zmwlj96ys6hj">
        <SectionNav sections={sections} activeId={activeId} isDone={isDone} doneCount={done.filter(id => id !== 'need-a-hand').length} scrollProgress={scrollProgress} data-id="element-3" data-mp="38lrnua6w0wfk" />

        <main className="min-w-0 flex-1 space-y-5 px-5 pt-8 sm:space-y-6 sm:px-8 lg:px-0 lg:pt-0" data-id="element-4" data-mp="nwc2vvuco1xu">
          {sections.map(section => <Reveal key={section.id} data-id="element-5" data-mp="sssrss9dikbz">
              <SectionCard section={section} done={isDone(section.id)} onToggleDone={() => toggle(section.id)} tone={section.kind === 'white-glove' ? 'together' : 'default'} data-id="element-6" data-mp="36877lhgoowl">
                {section.kind === 'tour' && <>
                    {section.steps && <StepList steps={section.steps} data-id="element-7" data-mp="864a1hefaaak" />}
                    {section.areas && <TourAreas areas={section.areas} data-id="element-8" data-mp="3gklb8561bk84" />}
                  </>}

                {section.kind === 'white-glove' && section.togetherPoints && <TogetherPanel intro={togetherIntro[section.id] ?? ''} points={section.togetherPoints} data-id="element-9" data-mp="3qaxrhl6tgr8g" />}

                {section.kind === 'explore' && section.items && <ExploreGrid items={section.items} data-id="element-10" data-mp="2xtbyln0ywfcb" />}

                {section.kind === 'steps' && section.steps && <StepList steps={section.steps} data-id="element-11" data-mp="18dri7slud9c8" />}
              </SectionCard>
            </Reveal>)}

          <Reveal className="pt-2" data-id="element-12" data-mp="1d4recvn4zndo">
            <NeedAHand data-id="element-13" data-mp="1d5sqz4jswhxi" />
          </Reveal>
        </main>
      </div>
    </div>;
}